import React from 'react';

import {useLecturesByIds, UseLecturesByIdsResult} from '../../hooks/use-lectures-by-ids';

export const LECTURE_IDS_DEV = [
    '20054238',
    '20262744',
    '20263106',
    '20054392',
    '20054462',
    '20263094',
    '20054584',
    '20281863',
    '26623452',
    '20208108',
];

export const LECTURE_IDS_PROD = [
    '53942411',
    '53942727',
    '53942733',
    '53942741',
    '53942747',
    '53942751',
    '53942755',
    '54271747',
    '53942763',
    '53942773',
    '53942787',
    '54376761',
];

export const withFreeResourcesLecturesData = <T extends object>(
    WrappedComponent: React.ComponentType<T & {lecturesResult: UseLecturesByIdsResult}>,
): React.ComponentType<T> => {
    return (props: T) => {
        const lectureIds = process.env.DEPLOY_ENV === 'prod' ? LECTURE_IDS_PROD : LECTURE_IDS_DEV;
        const lecturesResult = useLecturesByIds(lectureIds);

        return <WrappedComponent {...props} lecturesResult={lecturesResult} />;
    };
};
